import { render, staticRenderFns } from "./PortBasis.vue?vue&type=template&id=1317ab48&scoped=true"
import script from "./PortBasis.vue?vue&type=script&lang=js"
export * from "./PortBasis.vue?vue&type=script&lang=js"
import style0 from "./PortBasis.vue?vue&type=style&index=0&id=1317ab48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1317ab48",
  null
  
)

export default component.exports